import React from 'react';
import PropTypes from 'prop-types';

// DS
import { Col, VertTypography } from '@vertem-core/vertice-ds';

// STYLES
import 'Assets/styles/default/components/Cart/CartItemValueStyles.less';

// UTILS
import { useSelector } from 'react-redux';
import { pointsMask } from 'Utils/commons/points';

// CART ITEM VALUE COMPONENT
const CartItemValue = ({ value }) => {
  /* Hooks */
  const Catalog = useSelector(({ Catalog: data }) => data);
  const { currencyConfiguration: { decimalPlaces, pointsName } } = Catalog;

  /* Vars */
  const formattedValue = pointsMask(value, decimalPlaces, pointsName);

  /* Renders */
  return (
    <Col className="cart-item-value padding-x-none" >
      <VertTypography.Paragraph>
        {formattedValue.value}
      </VertTypography.Paragraph>
      <VertTypography.Paragraph className='label'>
        {formattedValue.label}
      </VertTypography.Paragraph>
    </Col>
  );
};

CartItemValue.propTypes = {
  value: PropTypes.number.isRequired
};

export default CartItemValue;
